import React, { useState, useEffect } from 'react'
import "./styles/Policies.css"
import Header from '../components/Header';
import Footer from '../components/Footer';

const Policies = () => {
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
    }, []);

    return (
        <>
            {/* <Header /> */}
            <div className={`policies-page home-page ${fadeIn ? "show" : ""}`}>
                <div className='policies-container fade-in show'>
                    <div className='section section1'>
                        <div className='page-header'>
                            <h2>Policies</h2>
                            <p>
                                Please click{" "}
                                <a
                                    href="https://www.instagram.com/bunnyklawz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to DM @bunnyklawz on Instagram for any questions!
                            </p>
                        </div>
                        <div className='policy-sections'>
                            <h2>Booking Policies</h2>
                            <ul>
                                <li>To confirm your appointment, a $10 deposit is required. If the deposit isn't received within 24 hours of booking, your appointment will be canceled. Please allow 24 hours for confirmation of your deposit.</li>
                                <li>While we send email and text confirmations for your appointment, responses won’t be monitored so all inquiries should be made via Instagram.</li>
                                <li>For special events and occasions (weddings, bridal, etc.) please contact us directly via Instagram.</li>
                            </ul>
                            <h2>Late Policies</h2>
                            <ul>
                                <li>We offer a 15-minute grace period from the scheduled appointment time. If you arrive after the grace period, your appointment will be canceled. We understand emergencies happen, so you'll be able to reschedule if needed.</li>
                                <li>If you arrive within the grace period but are still late, we may ask you to choose a simpler design to accommodate the remaining time.</li>
                            </ul>
                            <h2>Cancellation Policies</h2>
                            <ul>
                                <li>You can cancel your appointment up to 48 hours in advance and choose either a refund of your deposit or use it to reschedule for another available time.</li>
                                <li>If you cancel within 48 hours of your appointment or fail to show up, your deposit will not be refunded or applied to a future appointment.</li>
                            </ul>
                            <h2>Shop Policies</h2>
                            <ul>
                                <li>You’re welcome to bring guests, but please inform us in advance. We kindly ask that you limit it to 1-2 guests due to limited seating in the waiting area.</li>
                                <li>We ask that you treat our nail technicians, other guests, and the salon space with respect at all times.</li>
                            </ul>
                        </div>
                    </div>
                    <Footer />

                </div>

            </div>
        </>
    )
}

export default Policies